import { ListPerson } from "../../../schema/list";

/** Template token for the company name as a person would write it in an email (PREC-2748). */
export const NORMALIZED_COMPANY_NAME_KEY = "prospect_organization_nameNormalized";

/** True for `{prospect_organization_nameNormalized}` and its labelled `{key|Label}` form. */
export const isNormalizedCompanyNameKey = (key: string): boolean =>
	key.split("|")[0] === NORMALIZED_COMPANY_NAME_KEY;

/**
 * True when at least one template uses `{token}` or its labelled `{token|Label}` form.
 *
 * Mirrors the gate the send applies (`build-template-variables.util.ts`): resolving the value costs
 * an inference the first time, so a campaign that never mentions the variable must never pay for it.
 */
export const mentionsNormalizedCompanyName = (templates: (string | undefined)[]): boolean => {
	const pattern = new RegExp(`\\{${NORMALIZED_COMPANY_NAME_KEY}[|}]`);

	return templates.some((template) => !!template && pattern.test(template));
};

/**
 * What the preview shows for the normalized company name.
 *
 * `organization.nameNormalized` is filled lazily — by the first send that uses the token, or by the
 * backfill — so it is null for every lead nobody has messaged yet. The send falls back to the raw
 * company name in exactly that case (`build-template-variables.util.ts`), and the grid column does
 * the same, so the preview has to as well: anything else shows the user something the send will not
 * produce. Before PREC-3923 the preview stringified the null and rendered the literal word "null".
 */
export const resolveNormalizedCompanyName = (value: unknown, lead?: ListPerson | null): string => {
	if (typeof value === "string" && value.trim()) {
		return value;
	}

	return lead?.prospect?.organization?.name || "";
};
